<template>
    <div id="app">
        <v-app id="inspire">  
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">REQUEST APPOINTMENT</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>

                    <v-layout>
                        <v-container class="pr-0">
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>

                    <v-layout></v-layout>
                    <v-spacer></v-spacer>
                </v-container>
            </v-parallax>

            <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 lg12>
                            <div class="text-xs-center">
                                <v-flex xs12>
                                    <v-data-table :search="search" :headers="headers" :items="lists" class="elevation-1">
                                        <template v-slot:items="props">
                                            <td class="text-xs-left">{{ props.item.branch }}</td>
                                            <td class="text-xs-left">{{ props.item.formatedDate }}</td>
                                            <td class="text-xs-left">{{ props.item.appointmentTime }}</td>
                                            <td class="text-xs-left"> <div v-for="(service,index) in props.item.initialService" :key="index">{{service.displayName }} </div>
                                            <div v-for="(service,index2) in props.item.otherService" :key="index2">{{service.service }} </div>
                                            </td>
                                            <td class="text-xs-left">{{ props.item.userDetails.fullName }}</td>
                                            <td class="justify-center">
                                                <v-btn small outline color="primary" @click="requestForChange(props.item)">view</v-btn>
                                            </td>
                                        </template> 

                                        <template v-slot:no-data>
                                            <v-alert :value="true" color="grey">
                                                No Data Available
                                            </v-alert>
                                        </template>

                                        <template v-slot:no-results>
                                            <v-alert :value="true" color="error" icon="warning">
                                                Your search for "{{ search }}" found no results.
                                            </v-alert>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </div>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-dialog v-model="editDialog" persistent max-width="80%">
                <v-card v-if="forChange.userDetails">
                    <v-container fluid class="pa-0" grid-list-md>
                        <v-parallax dark class="blue-grey darken-3" height="70">
                            <v-layout>
                                <v-card-title class="title font-weight-black"> 
                                    {{forChange.branch}} 
                                </v-card-title>
                                <v-spacer></v-spacer>
                                <v-btn dark  icon @click="editDialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn> 
                            </v-layout>
                        </v-parallax> 

                        <v-layout wrap> 
                            <v-flex xs4>
                                <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                    Owner: {{forChange.userDetails.fullName}}
                                </v-card-title>

                                <v-card-title v-if="forChange.userDetails.address" class="subtitle-1 font-weight-black pb-0 pt-0"> 
                                    Address: {{forChange.userDetails.address.city}} {{forChange.userDetails.address.state}}
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pb-0 pt-0"> 
                                    Mobile Number: {{forChange.userDetails.mobileNumber}}
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                    Email: {{forChange.userDetails.email}}
                                </v-card-title>
                            </v-flex>

                            <v-flex xs4>
                                <v-card-title class="subtitle-1 font-weight-black pb-0"> 
                                    Dealer: {{forChange.motorcycleDetails.dealer}}<br>
                                    Model: {{forChange.motorcycleDetails.model}}
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                    Mileage: {{forChange.odometer}} km
                                </v-card-title>
                            </v-flex>

                            <v-flex xs4>
                                <v-card-title class="subtitle-1 font-weight-black pt-2 pb-0"> 
                                    Date: {{forChange.formatedDate}}
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                    Schedule Time: {{forChange.appointmentTime}}
                                </v-card-title>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>

                        <v-layout>
                            <v-flex xs7 justify-center class="pt-0">
                                <v-container grid-list-sm fluid>
                                    <v-layout row wrap class="justify center">
                                        <v-flex xs7 v-for="(service,index) in serviceMenu" :key="index" class="pt-0">
                                            <v-card-actions class="pt-0 pb-0">
                                                <v-checkbox v-model="selected.service" :label="service.displayName" :value="service"></v-checkbox>
                                            </v-card-actions>
                                            <v-card-title class="caption font-weight-regular pt-0 pb-0">{{service.displayDescription}}
                                            </v-card-title>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>

                            <v-flex xs5>
                                <v-container>
                                    <v-layout v-for="(list,index) in otherServices" :key="index">
                                        <v-flex xs8>
                                            <v-text-field class="pl-4" v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required readonly>
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs4>
                                            <v-select v-model="otherServices[index].time" :items="otherTimeRate" label="Time" required
                                            > </v-select>
                                        </v-flex>
                                    </v-layout>

                                    <v-card-actions class="justify-end">
                                        <v-btn color="red accent-4" @click="rejectDialog=true" dark>Reject</v-btn>
                                        <v-btn color="green darken-4" @click="approveDialog=true" dark>Approve</v-btn>
                                    </v-card-actions>
                                </v-container>
                            </v-flex>
                        </v-layout>
           
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog" persistent width="300">
                <v-card  color="primary">
                    <v-card-text class="subheading white--text"> {{progressMessage}}
                        <v-layout row justify-center>
                        <v-progress-linear :indeterminate="true"
                            :size="70"
                            :width="5"
                            color="white"
                        ></v-progress-linear>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="snackbar" bottom right :color="snackbarColor">{{ snackbarMessage }} 
                <v-btn dark small flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-dialog v-model="rejectDialog" max-width="500px" persistent>
                <v-card>
                    <v-parallax dark class="blue-grey darken-3" height="80">
                        <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to reject this appointment in the list? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to remove the request schedule appointment in the list.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <div class="pl-3 pr-3 pb-3 pt-0">
                            <v-select v-model="remarks" outline label="Reason" required :items="reasons" hide-details
                            ></v-select>
                        </div>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="rejectDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="rejectValidation(forChange,'Rejected')">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="approveDialog" max-width="500px" persistent>
                <v-card>
                    <v-parallax dark class="blue-grey darken-3" height="80">
                        <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to approve this appointment in the list? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to queue the request schedule appointment in the list.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-text class="subheading font-weight-regular pt-0 pb-0 pl-3 pr-3">Remarks</v-card-text>
                        <v-textarea class="subheading font-weight-regular pt-0 pb-0 pl-3 pr-3" outline solo v-model="remarks"></v-textarea>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="approveDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="approveValidation(forChange,'Waiting')">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>

        </v-app>
    </div>
</template>


<script>
import _ from "lodash"
import store from "../stores"
import firebase from "firebase"
import {db} from "../main"
import { mapGetters, mapState } from "vuex"
import { setTimeout } from "timers"
import { functions } from "firebase"
import moment from 'moment'

export default {
    data: () => ({
        date: moment().utcOffset('+0800').toISOString().substr(0, 10),
        headers: [
            { text: 'Branch', align: 'left', sortable: true, value: 'branch'},
            { text: 'Date', align: 'left', sortable: true, value: 'transactionId'},
            { text: 'Time', align: 'left', value: 'customerType',  sortable: false  },
            { text: 'Services', align: 'left', value: 'appointmentDate',  sortable: true  },
            { text: 'Customer Name', align: 'left', value: 'appointmentDate',  sortable: true  },
            { text: 'Action', align: 'center'}
        ],
        dialog: false,
        progressMessage: "Loading Data...",
        snackbarMessage: "",
        snackbarColor: "primary",
        snackbar: false,
        search: "",
        lists: [],
        events: [],
        editDialog: false,
        branch: "",
        forChange: {},
        serviceMenu: [],
        otherServices: [{
            service: "",
            price: 0,
            time: 0,
        }],
        selected: {
            service: []
        },
        otherTimeRate: [],
        timeHolder: [],
        estimateTime: 0,
        status: "",
        reservedTime: [],
        rejectDialog: false,
        timeValidation: [],
        timeValidation2: [],
        times: [],
        laps: [],
        remarks: "",
        approveDialog: false,
        reasons: [],
        bufferTime: 0,
        mcDetails: {},
        mechanic: "",
    }),

    methods : {
        async fetchReasons(){
            let self = this
            self.reasons = []

            db.collection("Settings"+self.$stage).doc("Rejection")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    self.reasons.push(doc.data().reason)
                })
            }).catch(function(error){
                console.log(error)
                self.snackbar = true
                self.snackbarMessage = "Reason for rejection should be set"
                self.snackbarColor = "error"
            })
        },

        async fetchBufferTime() {
            let self = this
            await db.collection("Settings"+self.$stage).doc("BufferTime")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.bufferTime = 0
                        self.snackbar = true
                        self.snackbarMessage = "Buffer time should be set"
                        self.snackbarColor = "error"
                    } else {
                        self.bufferTime = doc.data().time
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.snackbar = true
                self.snackbarMessage = "Buffer time should be set"
                self.snackbarColor = "error"
            })
        },

        async fetchFlatRate() {
            let self = this    
            self.otherTimeRate = []
            let count = 0

            await db.collection("Settings"+self.$stage).doc("FlatRate")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    count ++
                    if (!doc.exists) {
                        self.snackbarColor = "error"
                        self.snackbarMessage = "Flat Rate should be set"
                        self.snackbar = true
                    } else {
                        self.otherTimeRate.push(doc.data().time)
                    }

                    if (count === querySnapshot.docs.length) {
                        self.otherTimeRate.sort(function(a, b){return a-b})
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.snackbarColor = "error"
                self.snackbarMessage = "Flat Rate should be set"
                self.snackbar = true
            })
        },

        async fetchTransactions() {
            let self = this
            self.dialog = true
            self.progressMessage = "Loading Data..."

            await db.collection("ServiceBooking"+self.$stage)
            .onSnapshot(function(querySnapshot) {
               self.lists = []
                querySnapshot.forEach(function(doc) {
                    if (doc.data().status === "ForApproval") {
                        self.lists.push(doc.data())
                    }
                })
            })
            self.dialog = false
        },


         // ********* ESTIMATION OF LABOR COST AND TIME *************
        chargeEstimate() {
            let self = this
            self.timeHolder = []
            self.selected.service.forEach(function (result) {
                self.timeHolder.push(Number(result.time))
            })
            self.otherServices.forEach(function (result) {
                self.timeHolder.push(Number(result.time))
            })
            self.estimateTime =  (self.timeHolder.reduce(function(a, b) { return a + b }, 0))
        },

        fetchServiceMenuPerClass(){
            let self = this
            let list = []
            let count = 0
            self.serviceMenu = []

            db.collection("ServiceMenu"+`${self.$stage}`).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status === "active"){
                        list.push(doc.data())
                    }
                })
            }).then(function(){
                list.forEach(function(result){
                    result.classifications.forEach(function(data){
                        if (data.class === self.mcDetails.classification) {
                            self.serviceMenu.push({
                                jobCode: "",
                                id: result.id,
                                displayName: result.serviceName,
                                displayDescription: result.description,
                                time: data.time,
                                classification: data.class
                            })
                            count ++
                        }
                    })
                })

                if (count === list.length) {
                    self.serviceMenu.sort()
                    self.dialog=false
                    self.editDialog = true
                }
            }).catch(function(error) {
                console.log(error)
                self.dialog=false
                self.showdialog= true,
                self.dialogMsg= "Error fetching service menu"
                self.dialogColor= "error"
            })
        },

        requestForChange(forChange){
            let self = this
            self.editDialog = true  
            self.forChange = forChange
            self.fetchMechanics()
            self.selected.service = self.forChange.initialService
            self.otherServices = self.forChange.otherService
            self.mcDetails = self.forChange.motorcycleDetails
            if (self.mcDetails.classification != "" ) {
                self.fetchServiceMenuPerClass()
            }
        },

        rejectValidation(data, status) {
            let self = this
            if (self.remarks === "" || self.remarks === null) {
                self.snackbar = true
                self.snackbarMessage = "Please insert remarks!"
                self.snackbarColor = "error"
            } else {
                self.editDialog=false
                self.rejectDialog=false
                self.updateTransaction(data, status)
            }
        },

        approveValidation(data,status) {
            let self = this
            if (self.reservedTime.includes(data.appointmentTime)) {
                self.snackbar = true
                self.snackbarMessage = "Time is already taken!"
                self.snackbarColor = "error"
            } else {
                self.editDialog=false
                self.approveDialog=false
                self.updateTransaction(data, status)
            }
        },

        updateTransaction(data,status) {
            let self = this
            let removedFromDb = []
            let index = []
            self.timeValidation = []
            
            self.timeValidation = {
                appointmentTime: data.appointmentTime,
                blockTime: self.estimateTime / self.bufferTime
            }
            index = self.times.indexOf(self.timeValidation.appointmentTime)
            removedFromDb = self.times.splice(index, self.timeValidation.blockTime)

            db.collection("ServiceBooking"+self.$stage).doc(data.transactionId)
            .update({
                otherService: self.otherServices,
                status: status,
                remarks: self.remarks,
                estimateTime: self.estimateTime,
                timeHold: removedFromDb,
                dateApproval: moment().format('MMMM Do YYYY, h:mm:ss a')
            }).then(function() {
                self.notifications(data,status)
                self.snackbarColor = "success"
                self.snackbarMessage = "Updated Successfully"
                self.snackbar = true
            })
        },

        async fetchTimes() {
            let self = this

            await db.collection("ServiceBooking"+self.$stage)
            .where("branchCode","==",self.forChange.branchCode)
            .where("appointmentDate","==",self.forChange.appointmentDate)
            .where("mechanic","==",self.mechanic)
            .where("status","==","Waiting")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(res) {
                    self.reservedTime.push(res.data().appointmentTime)
                })
            })
        },

        async fetchMechanics(details){
            let self = this
            let availableTime = []
            let removedFromDb = []
            let blockTime = 0
            let appointmentTime = ""
            let index = []
            self.removed = []
            self.timeValidation = []

            await db.collection("Mechanics"+self.$stage)
            .where("name","==",self.forChange.mechanic)
            .where("branchCode","==",self.forChange.branchCode)
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.times = doc.data().time
                    if (doc.data().tag === true) {
                        self.mechanic = doc.data().name
                    }
                })
            }).then(function() {
                db.collection("ServiceBooking"+self.$stage)
                .where("mechanic","==",self.forChange.mechanic)
                .where("appointmentDate","==",self.forChange.appointmentDate)
                .where("status","==","Waiting")
                .get().then(function(querySnapshot) {
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach(function(doc) { 
                            self.timeValidation.push({
                                appointmentTime: doc.data().appointmentTime,
                                blockTime: doc.data().estimateTime / self.bufferTime
                            })
                        })

                        self.timeValidation.forEach(function(val) {
                            index = self.times.indexOf(val.appointmentTime)
                            removedFromDb = self.times.splice(index, val.blockTime)
                        })
                    }
                })
            }).then(function() {
                self.fetchTimes()
            })
        },

        notifications(details,status){
            let self = this
            let branch = self.forChange.branch
            let source = ""
            //************************ S M S   N O T I F I C A T I O N **************************/
            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType
        
            let footer = "Note: The services and estimated labor cost are subject to change upon actual diagnosis of the branch service mechanic.".italics()
            
            let message = "Dear " + details.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! This is to confirm that you are successfully scheduled for service on " + details.formatedDate + " at "+ branch+ " with control number "+ details.transactionId +". \n\n" + "Click here to see full details of your appointment".link(self.$clientUrl + "/transactions") + "\n\n" + "Please arrive at least 15 minutes before the time to avoid being tagged as a no show. Thank you." + "\n\n" + footer

            let emailMessage = message.replace(/(\r\n|\n|\r)/gm, "<br>")

            let smsmessage = "Dear " + details.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! This is to confirm that you are successfully scheduled for service on " + details.formatedDate + " at "+ branch+ " with control number "+ details.transactionId +". \n\n" + "Click here to see full details of your appointment: " + self.$clientUrl + "/transactions" + "\n\n" + "Please arrive at least 15 minutes before the time to avoid being tagged as a no show. Thank you." + "\n\n" + "Note: The services and estimated labor cost are subject to change upon actual diagnosis of the branch service mechanic."

            if (branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (branch.includes("Powercycle")) {
                source = "Powercycle" 
            }

            if (status == "Waiting") {
                let body = {
                    "source": source,
                    "destination": `63${details.userDetails.mobileNumber}`,
                    "text": smsmessage,
                    "subaccount": self.$subAccount
                }
                self.$axios.post(self.$smsUrl, body)
            } else {
                self.rejectDialog = false
                let rejectMsg = "Dear " + details.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! We are sorry to inform you that your scheduled for service on "+ details.formatedDate + " at "+ details.branch + " with Control #: " + details.transactionId + " has been rejected due to " + self.remarks + "." + "\n\nYou can always set another schedule or feel free to visit our branches"

                let body = {
                    "source": source,
                    "destination": `63${details.userDetails.mobileNumber}`,
                    "text": rejectMsg,
                    "subaccount": self.$subAccount
                }
                self.$axios.post(self.$smsUrl, body).then(function(){
                    self.remarks = ""
                })
            }

            //************************ E M A I L   N O T I F I C A T I O N **************************/
            if (status == "Waiting") {
                let load = {
                    "receiver" : details.userDetails.email,
                    "subject" : "Your appointment has been confirmed",
                    "html" : emailMessage
                }
                self.$axios.post(self.$mailerUrl, load)
            } else {
                self.rejectDialog = false
                let rejectMsg = "Dear " + details.userDetails.firstName + ",\n\nI am sorry to inform you that your request service schedule appointment is rejected due to " + self.remarks +"." + "\n\nYou can still visit us at our store."
                let emailRejectMsg = rejectMsg.replace(/(\r\n|\n|\r)/gm, "<br>")

                let load = {
                    "receiver" : details.userDetails.email,
                    "subject" : "Your appointment has been rejected",
                    "html" : emailRejectMsg
                }
                self.$axios.post(self.$mailerUrl, load).then(function(){
                    self.remarks = ""
                })
            }
        }
    },

    mounted() {
        this.fetchFlatRate()
        this.fetchBufferTime()
        this.fetchReasons()
        this.fetchTransactions()
    },

    computed: {
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        otherServices: {
           handler: function(newValue) {
                this.chargeEstimate()
           },
           deep: true
        },
    },
}
</script>
